/**
 * Utility functions for handling rating display
 */

/**
 * Safely formats a rating value to one decimal place
 * Handles both number and string inputs
 * @param rating - The rating value (number or string)
 * @returns Formatted rating string or 'N/A' if invalid
 */
export const formatRating = (rating: number | string | null | undefined): string => {
  if (!rating) return 'N/A';
  
  const numRating = typeof rating === 'number' ? rating : parseFloat(rating);
  
  if (isNaN(numRating)) return 'N/A';
  
  return numRating.toFixed(1);
};

/**
 * Safely formats a review count
 * @param reviews - The review count (number or string)
 * @returns Formatted review count or 0 if invalid
 */
export const formatReviewCount = (reviews: number | string | null | undefined): number => {
  if (!reviews) return 0;
  
  const numReviews = typeof reviews === 'number' ? reviews : parseInt(reviews);
  
  return isNaN(numReviews) ? 0 : numReviews;
};
